
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.283 7.315l-8.762-3.271a.499.499 0 00-.409 0L5.41 7.314A.561.561 0 005 7.842v7.652c0 6.834 8.704 11.273 9.054 11.449.058.058.175.058.234.058.058 0 .175 0 .233-.058.468-.176 9.171-4.615 9.171-11.45V7.842a.561.561 0 00-.409-.526z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M14.5 10a5.5 5.5 0 100 11 5.5 5.5 0 000-11zm3.176 3.758l-3.14 4.258a.46.46 0 01-.655.087l-2.241-1.792a.458.458 0 01-.069-.646.458.458 0 01.637-.069l1.87 1.494 2.86-3.882a.459.459 0 01.823.206.458.458 0 01-.085.344z","fill":"#fff"}})])
          )
        }
      }
    